import React, { Component } from "react";
import { userService } from "../_services/user.service";
import { userConstants } from "../_constants/user.constants";

class AutoSessionOut extends Component {
    constructor(props) {
        super(props);

        this.events = [
            "load",
            "mousemove",
            "mousedown",
            "click",
            "scroll",
            "keypress"
        ];

        this.createSession = this.createSession.bind(this);
        this.callSessionExpire = this.callSessionExpire.bind(this);

        for (var i in this.events) {
            window.addEventListener(this.events[i], this.createSession);
        }

        this.createSession();

        setInterval(() =>
            this.callSessionExpire(),
            1000);
    }

    clearTimeout() {
        if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
    }

    callSessionExpire() {
        let lastSessionTime = new Date(localStorage.getItem("lastSessionTime"));
        let defaultMins = parseInt((this.props.timeOut ? this.props.timeOut : 30));
        lastSessionTime.setMinutes(lastSessionTime.getMinutes() + defaultMins);
        let currentTime = new Date();
        if (currentTime > lastSessionTime) {
            console.log("condition time session");
            //this.props.fnSessionLogout.fnSessionLogout();
            sessionStorage.setItem("sessionOut", true);
            userService.logout();
            window.location.href = window.location.origin + "/#/login";
            return { type: userConstants.LOGOUT };
        }
    }

    createSession() {
        var dt = new Date();
        localStorage.setItem("lastSessionTime", dt);
    }

    render() {
        return (
            <React.Fragment>
            </React.Fragment>
        )
    }
};

export default AutoSessionOut;